import { getDaysInPersianMonth } from "persian-leap";

/**
 * Validate a Persian date.
 * @param year The year
 * @param month The month (1-12)
 * @param day The day
 * @returns `true` if the date is valid, `false` otherwise.
 */
export function isPersianDateValid(year: number, month: number, day: number): boolean {
	if (year < 1) {
		return false;
	}

	if (month < 1 || month > 12) {
		return false;
	}

	const daysInMonth = getDaysInPersianMonth(year, month);
	if (day < 1 || day > daysInMonth) {
		return false;
	}

	return true;
}
